__turbopack_context__.v({
  "pagination": "pagination-controls-module__vBFdAW__pagination",
});
